import { Injectable } from '@angular/core';
import { Observable, Subject, tap, timer } from 'rxjs';
import { EMessageStatus, IMessage } from '../model/message.model';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private messageSource$ = new Subject<IMessage | IMessage[]>();
  private clearSource$ = new Subject<string>();

  getMessageSource(): Observable<IMessage | IMessage[]> {
    return this.messageSource$.asObservable();
  }

  /** Add a single Message. */
  add(message: IMessage): void {
    this.messageSource$.next(message);
  }

  /** Add an array of messages */
  addAll(messages: IMessage[]): void {
    if (messages.length > 0) {
      this.messageSource$.next(messages);
    }
  }

  getClearObserver(): Observable<string> {
    return this.clearSource$.asObservable();
  }

  /** Clears source subject. */
  clear(key?: string): void {
    if (key) {
      this.clearSource$.next(key);
    }
  }

  /**
   * Reusable helper function to trigger delayed messages - mainly used for after navigation or animation
   * @param delay ms
   * @param severity message status
   * @param detail translation string
   * @returns timer observable
   */
  addDelayedMessage(delay: number, severity: EMessageStatus, detail: string): Observable<0> {
    const customToast: IMessage = { severity, detail };

    return timer(delay).pipe(tap(() => this.add(customToast)));
  }
}
